<h3>About the authors</h3>
<p>
    We are <a href="https://www.linkedin.com/in/aron-granberg-5940a446">Aron Granberg</a> and
    <a href="https://www.linkedin.com/in/m%C3%A5rten-wiman-678171b3/">Mårten Wiman</a>, two passionate programmers from
    Stockholm who are always looking for interesting problems to solve. Reach out to us at
    <a href="mailto:contact@optimeringsfabriken.se">contact@optimeringsfabriken.se</a> if you have an interesting project
    in need of programmers, or if you just want to say hi.
</p>
